import API from "@/API";

const SET_LIST = "SET_LIST";
const SET_PRELOADER = "SET_PRELOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_SORT = "SET_SORT";
const SET_SELECTED_TRANSFER = "SET_SELECTED_TRANSFER";
const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";
const SET_PGA = "SET_PGA";
const RESET = "RESET";

export default {
  namespaced: true,

  state: {
    list: [],
    paymentGatewayAccount: "",
    selected: { id: "" },
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    textSearch: "",
    preloader: false
  },

  actions: {
    async create({ commit }, data) {
      try {
        await API.Transfers.create(data);
        return true;
      } catch (error) {
        throw error;
      }
    },
    async listAll({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.Transfers.index(
          state.pagination.current,
          state.sort,
          state.textSearch
        );

        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },
    async listByPGA({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.PaymentGatewayAccount.getTransfers(
          state.paymentGatewayAccount,
          state.pagination.current,
          state.sort,
          state.textSearch
        );

        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        commit("SET_PRELOADER", false);
        throw e;
      }

      commit("SET_PRELOADER", false);
    },
    setCurrentPage({ commit, dispatch, state }, page) {
      commit("SET_CURRENT_PAGE", page);
      if (state.paymentGatewayAccount == "") {
        dispatch("listAll");
      } else {
        dispatch("listByPGA");
      }
    },
    setSort({ commit, dispatch }, payload) {
      commit("SET_SORT", payload);
      if (state.paymentGatewayAccount === "") {
        dispatch("listAll");
      } else {
        dispatch("listByPGA");
      }
    },
    setSelectedTransfer({ state, commit }, payload) {
      if (state.selected.id === payload.id) payload = false;
      commit("SET_SELECTED_TRANSFER", payload);
    },
    setTextSearch({ state, commit, dispatch }, payload) {
      commit("SET_TEXT_SEARCH", payload);
      commit("SET_CURRENT_PAGE", 1);
      if (state.paymentGatewayAccount === "") {
        dispatch("listAll");
      } else {
        dispatch("listByPGA");
      }
    },
    setPaymentGatewayAccount({ commit }, pgaId) {
      commit("SET_PGA", pgaId);
    },
    resetState({ commit }) {
      commit("RESET");
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    },
    [SET_SORT](state, payload) {
      state.sort = payload;
    },
    [SET_SELECTED_TRANSFER](state, payload) {
      state.selected = payload;
    },
    [SET_TEXT_SEARCH](state, payload) {
      state.textSearch = payload;
    },
    [SET_PGA](state, payload) {
      state.paymentGatewayAccount = payload;
    },
    [RESET](state) {
      state.list = [];
      state.paymentGatewayAccount = "";
      state.selected = { id: "" };
      (state.pagination = {
        current: 1,
        totalPages: 1,
        totalResults: 1
      }),
        (state.sort = "");
      state.textSearch = "";
      state.preloader = false;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/transfers.js